import React, { useEffect } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { useSiteData } from "@/context/SiteDataContext"; // Adjust the import based on your project structure
import Title from "@/components/shared/Title";

const Testimonials = () => {
  const { siteData, loading } = useSiteData();
  const testimonials = siteData?.testimonials || [];

  useEffect(() => {
    const slides = document.querySelectorAll(".splide__slide[role='tabpanel']");
    slides.forEach((slide) => {
      slide.removeAttribute("role");
      slide.removeAttribute("aria-roledescription");
    });
  }, []);

  if (loading) {
    return <p className="py-10 text-center">Loading testimonials...</p>;
  }

  return (
    <section className="bg-tertiary px-4 py-12 text-center text-white">
      <div className="flex flex-col items-center text-white">
        <Title title="Testimonials" className="mb-6 xl:mb-12" />
      </div>

      <h2 className="mb-8 text-2xl font-medium xl:text-3xl xl:font-bold">
        Building trust through the voices <br /> of those we’ve supported
      </h2>
      <Splide
        options={{
          type: "loop",
          autoplay: true,
          interval: 2000, // Interval between slides (2 seconds)
          pauseOnHover: true,
          arrows: false, // Hide the arrows
          pagination: true, // Show dots for navigation
          drag: true, // Allow drag
          loop: true, // Enable infinite loop
          rewind: true, // Add rewind for smoother looping
          focus: "center", // Center the active slide
          resetProgress: true, // Keep progress when looping
        }}
        className="splide"
      >
        {testimonials.map((testimonial, index) => (
          <SplideSlide key={index}>
            <div className="mx-auto w-full rounded-tr-[20px] rounded-bl-[20px] border-[0.5px] border-white/30 p-6 text-center md:w-1/3">
              <img
                src={testimonial.author.image}
                alt={testimonial.author.name}
                className="mx-auto mb-4 h-20 w-20 rounded-full"
              />
              <h3 className="text-xl font-semibold">
                {testimonial.author.name}
              </h3>
              <p className="text-primary">{testimonial.author.position}</p>
              <p className="mt-4 text-white">{testimonial.quote}</p>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </section>
  );
};

export default Testimonials;
